<script lang="ts">
    
    import { getContext, onDestroy } from "svelte";    
    import { get } from "svelte/store";
    import { AccordionItem, Badge, Icon } from "sveltestrap";
    import type { Fn, GetAnswerFn } from "../../global";
    import type { Section } from "../../Model/Section";
    import type SectionInstance from "../../Model/SectionInstance";
    import { SubsriptionsManager } from "../../Model/SubsriptionsManager";
    import { answerInvalidateForm, instancesService } from "../../Services";
    import FormSection from "./FormSection.svelte";

    export let number: number;
    export let instanceId: string;
    export let section: Section;
    export let sectionInstance: SectionInstance;

    const questionSubscriptions = new SubsriptionsManager();
    const getAnswer: GetAnswerFn = getContext('getAnswer');
    const updateValidationState: Fn = getContext('updateValidationState');

    let isInvalidated = false;
    let accordionClass = '';
    let isRequired = true;

    $: setupComponent(section);

    onDestroy(() => questionSubscriptions.unsubscribe());

    function setupComponent(section: Section): void {
        isRequired = get(sectionInstance.required);
        questionSubscriptions.unsubscribe();
        for (const question of section.questions) {
            const answer = getAnswer(question.id);
            questionSubscriptions.subscribe(answer.valueReadable, checkInvalidated);
        }
    }

    function checkInvalidated(): void {
        isInvalidated = section.questions.some(question => {
            const answer = getAnswer(question.id);
            return answerInvalidateForm(question, answer.value);
        });
        accordionClass = isInvalidated ? 'section-item-invalid' : '';
    }

    async function onIsRequiredChange(): Promise<void> {
        try {
            await instancesService.setSectionInstanceRequiredState(instanceId, section.id, isRequired);
            sectionInstance.required.set(isRequired);
            updateValidationState();
        } catch (error) {
            console.error(error);
        }
    }

</script>

<AccordionItem class={accordionClass}>
    <div slot="header" class="section-header">
        <h5 class="m-0">
            {#if isInvalidated}
                <Icon name="exclamation-diamond-fill" />
            {/if}
            {number}.- {section.name}
        </h5>

        {#if section.required}
            <Badge color="warning">Requerida</Badge>
        {:else}
            <div class="form-check">
                <label class="form-check-label" for={`is-required-${section.id}`} on:click|stopPropagation>
                    Aplica
                </label>
                <input
                    id={`is-required-${section.id}`}
                    type="checkbox"
                    class="form-check-input"
                    on:click|stopPropagation
                    bind:checked={isRequired}
                    on:change={onIsRequiredChange}
                    disabled={section.required}>
            </div>
        {/if}
    </div>
    <FormSection {section} />
</AccordionItem>

<style lang="scss">

    :global(.section-item-invalid .accordion-button) {
        background-color: var(--bs-danger) !important;
        color: #fff !important;
    }

    .section-header {
        flex: 1 1 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 1rem;
    }

</style>
